import { i18n } from '@/services/i18n';
import { LoadEventType, LoadEventTypeValues } from '@/interfaces/server-data';

const RU_LABEL_TO_KEY: Record<string, LoadEventType> = {
  'Изменение закупочной цены': LoadEventTypeValues.CHANGING_PURCHASE_PRICE,
  'Изменение цен конкурентов при мониторинге': LoadEventTypeValues.CHANGING_COMPETITORS_PRICE,
  'Изменение МРЦ': LoadEventTypeValues.CHANGING_MRP,
  'Новинки': LoadEventTypeValues.ADDING_NEW_PRODUCT,
  'Изменение линеек': LoadEventTypeValues.CHANGING_LINES,
  'Реактивация товара': LoadEventTypeValues.REACTIVATING_PRODUCT,
};

export function translateEventTriggerLabel(rawLabel: string): string {
  const trimmed = rawLabel.trim();
  const key = RU_LABEL_TO_KEY[trimmed];
  if (!key) {
    return trimmed;
  }
  return i18n.t(`events.types.${key}`) as string;
}

export function formatEventTriggerTypes(raw: string | null | undefined): string {
  if (!raw) {
    return '';
  }
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .map(translateEventTriggerLabel)
    .join(', ');
}

export function formatPurchasePriceDeviationPercent(value: number | null | undefined): string {
  if (value == null || isNaN(value)) {
    return '';
  }
  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(2)} %`;
}
